import
{
    permissionAllowed,
    SystemOperate,
    SystemType
} from "@ews/react-data";

import { useL10n } from "@ews/react-localization-context";
import { IonButton, IonItem, IonLabel, IonNote } from "@ionic/react";
import { useState } from "react";
import { useMyDateFormat, useMyPermissions } from "../../../Login/LoginProvider";
import
{
    useModifySystemMigrateRequest,
    useOperateSystem,
    useSystem,
    useSystemMigrateRequest,
} from "../../../ReactData/system";

import { useUserName } from "../../../ReactData/user";
import SettingsCol from "../../../Settings/SettingsCol/SettingsCol";
import SettingsDropFile from "../../../Settings/SettingsComponents/SettingsDropFile/SettingsDropFile";
import SettingsLabel from "../../../Settings/SettingsComponents/SettingsLabel/SettingsLabel";
import { DetailsSettingsProps } from "./types";
import { useInvokeCreateSystemSetup } from "../../../ReactData/rpc";
import { useAlert } from "../../../Dialog";
import { readFilesAsBase64Strings, SystemStatus } from "@ews/react-data";

import style from "../SettingsOverlay/SettingsOverlay.module.scss";
import { MigrateStatus, SystemMigrateRequest } from "@ews/react-data";


const DetailsSettings: React.FC<DetailsSettingsProps> = ({ systemId }) =>
{
    const system = useSystem(systemId);
    const systemMigrateRequest = useSystemMigrateRequest(systemId);
    console.log(systemMigrateRequest);
    const dateFormat = useMyDateFormat();
    const alert = useAlert();

    const modifiedByUser = useUserName(system.modifiedById || "", true);
    const createdByUser = useUserName(system.createdById || "", true);
    const operate = useOperateSystem();

    const invokeCreateSystemSetup = useInvokeCreateSystemSetup();

    const myPermissions = useMyPermissions();
    const allowedToEdit = permissionAllowed(myPermissions.grantSystemAccess || 0);

    const { translate: t } = useL10n();

    const [zonesCSV, setZonesCSV] = useState<File>();
    const [actuationsCSV, setActuationsCSV] = useState<File>();
    const createSystemMigrateRequest = useModifySystemMigrateRequest();


    async function saveXMLCFile(file: File)
    {
        if (!system.id) return;

        const binaryInput = await readFilesAsBase64Strings(file);
        console.log("binary", binaryInput);
        const response = await invokeCreateSystemSetup({ systemId: system.id, filesInJson: binaryInput });
        console.log("result of rpc", response);
    }

    const saveActuationsCSV = async (file: File) =>
    {
        setActuationsCSV(file);
        if (zonesCSV) {
            if (!system.id) return;

            const binaryInput = await readFilesAsBase64Strings([zonesCSV, file]);
            const response = await invokeCreateSystemSetup({ systemId: system.id, filesInJson: binaryInput });
            console.log("result of rpc", response);
        }
    };

    const saveZonesCSV = async (file: File) =>
    {
        setZonesCSV(file);
        if (actuationsCSV) {
            if (!system.id) return;

            const binaryInput = await readFilesAsBase64Strings([file, actuationsCSV]);
            const response = await invokeCreateSystemSetup({ systemId: system.id, filesInJson: binaryInput });
            console.log("result of rpc (csv)", response);
        }
    };

    return <>
        <SettingsCol >
            <SettingsLabel
                text="[SID_SYSTEM_KEY]"
                value={`${system?.systemKey || ''}`} />
            <SettingsLabel
                text="COM_FACPMANAGEMENT_FACP_FIELD_MAINTENANCE_CURRENT_DATE_LABEL"
                value={new Date().toLocaleString()} >
                <IonNote style={{ float: "right" }}>{t('COM_FACPMANAGEMENT_FACP_FIELD_MAINTENANCE_ALL_LABEL')}</IonNote>
            </SettingsLabel>
            <SettingsLabel
                text="COM_FACPMANAGEMENT_FACP_FIELD_ALARM_COUNTER_LABEL"
                value={"/alarmCounterToEN54_2".toString()} />

            <SettingsLabel
                text="COM_FACPMANAGEMENT_FACP_COUNT_OPERATIONS"
                value={`${system.inputDevices}`} />
            <SettingsLabel
                text="COM_FACPMANAGEMENT_FACP_COUNT_ACTUATIONS"
                value={`${system.outputDevices}`} />
            {system.systemType === SystemType.BC216 ?
                <>
                    <SettingsDropFile
                        text={"[REACT_ZONES_CSV_FILE]"}
                        onFile={(file) => saveZonesCSV(file)} />
                    <SettingsDropFile
                        text={"[REACT_ACTUATIONS_CSV_FILE]"}
                        onFile={(file) => saveActuationsCSV(file)} />
                </>
                :
                <SettingsDropFile
                    disabled={!allowedToEdit}
                    text={"COM_FACPMANAGEMENT_FACP_FIELD_ACTUATIONS_FILE_LABEL"}
                    onFile={(file) => saveXMLCFile(file)} />
            }
        </SettingsCol>
        <SettingsCol >
            <SettingsLabel
                text="COM_FACPMANAGEMENT_CUSTOMER_FIELD_CREATED_BY_USER_LABEL"
                value={createdByUser} />
            <SettingsLabel
                text="COM_FACPMANAGEMENT_AUTOMATEDMAIL_CREATED"
                value={system.created ? dateFormat(new Date(system.created!)) : ""} />
            <SettingsLabel
                text="COM_FACPMANAGEMENT_CUSTOMER_FIELD_MODIFIED_BY_USER_LABEL"
                value={modifiedByUser} />
            <SettingsLabel
                text="COM_FACPMANAGEMENT_CUSTOMER_FIELD_MODIFIED_LABEL"
                value={system.modified ? dateFormat(new Date(system.modified)) : ""} />
        </SettingsCol>
        <SettingsCol >
            {allowedToEdit && <IonItem>
                <IonButton
                    disabled={system.status !== SystemStatus.ONLINE}
                    expand="full"
                    className={style.btn}
                    onClick={async () =>
                    {
                        operate(systemId, { command: "REFRESH_DATA" } as SystemOperate);
                    }
                    }
                >
                    {t('[SID_OPER_REFRESH_DATA]')}
                </IonButton>
            </IonItem>}
            {allowedToEdit && <><IonItem lines="none">
                <IonButton
                    disabled={system.externalSource !== "React1" || (systemMigrateRequest.status || MigrateStatus.NONE) !== MigrateStatus.NONE || system.status !== SystemStatus.ONLINE}
                    expand="full"
                    className={style.btn}
                    onClick={async () =>
                    {

                        createSystemMigrateRequest(systemId, {} as SystemMigrateRequest);
                        // await alert({
                        //     "title": t('[REACT_REQUEST_EVENT_HISTORY]'),
                        //     "message": t('[REACT_REQUEST_EVENT_HISTORY_STARTED]'),
                        //     "buttonTitle": t('COM_TEMPLATES_TEMPLATE_CLOSE')
                        // });
                    }
                    }
                >
                    {t('[REACT_REQUEST_EVENT_HISTORY]')}
                </IonButton>


            </IonItem>
                {(systemMigrateRequest.status || MigrateStatus.NONE) !== MigrateStatus.NONE && <IonItem lines="none">
                    <IonLabel
                        color={systemMigrateRequest.status === MigrateStatus.DONE ? 'success' : 'warning'}>{t(`[REACT_REQUEST_EVENT_HISTORY_STATUS_${systemMigrateRequest.status}]`)}</IonLabel>

                </IonItem>}
            </>}
        </SettingsCol>
    </>;
};

export default DetailsSettings;
